// let host = 'https://sit02-eso-m.jmnet.cn';
let host = 'https://eso-m.jmnet.cn';

export default {
    queryListFromH5:`${host}/news/queryListFromH5`,
    getNewsTab:`${host}/news/getNewsTab`,
    queryInfoFromH5:`${host}/news/queryInfoFromH5`,
    queryNextOrPre:`${host}/news/queryNextOrPre`,
}
